var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9412 18.001C7.6442 16.728 6.3042 15.687 5.7542 15.001C4.81239 13.8242 4.22215 12.4054 4.05147 10.9079C3.88078 9.41042 4.1366 7.89516 4.78946 6.5367C5.44231 5.17823 6.46564 4.03182 7.74156 3.22953C9.01748 2.42725 10.4941 2.00171 12.0013 2.00195C13.5085 2.00219 14.985 2.4282 16.2606 3.2309C17.5363 4.0336 18.5592 5.18033 19.2117 6.539C19.8641 7.89768 20.1194 9.41302 19.9482 10.9105C19.7771 12.4079 19.1864 13.8265 18.2442 15.003C17.6942 15.688 16.3562 16.729 16.0592 18.001H7.9402H7.9412ZM16.0002 20.0009V21.0009C16.0002 21.5314 15.7895 22.0401 15.4144 22.4152C15.0393 22.7902 14.5306 23.0009 14.0002 23.0009H10.0002C9.46977 23.0009 8.96106 22.7902 8.58599 22.4152C8.21092 22.0401 8.0002 21.5314 8.0002 21.0009V20.0009H16.0002ZM13.0002 10.006V6.00095L8.5002 12.006H11.0002V16.0059L15.5002 10.006H13.0002Z",
    fill: "#0010F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.807963c7205003a01ffd8726dc09874d.svg";
export { ForwardRef as ReactComponent };